const init = () => {
    const addToCartButton = $('.btn-add-to-cart')
    const inputs = $('.product').find('.form-check input.toCart');
    const chooseAll = $('#chooseAll');

    inputs.on('click', function () {
        let anyChecked = false;
        inputs.each(function (i, e) {
            if ($(e).prop('checked')) {
                anyChecked = true;
                return false;
            }
        });
        if (anyChecked) {
            addToCartButton.removeAttr('disabled');
        } else {
            addToCartButton.attr('disabled', 'disabled');
        }

        if ($('#chooseAll').length > 0 && !$(this).prop('checked') && $('#chooseAll').prop('checked')) {
            $('#chooseAll').prop('checked', false);
        }

        if (inputs.filter(':checked').length === inputs.length) {
            chooseAll.prop('checked', true);
        }
    });

    chooseAll.on('click', function (e) {
        let checked = $(this).is(':checked');
        $('[data-app-cart="list"]').find('input.toCart').each(function (i, e) {
            if (checked) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });

        if (checked) {
            addToCartButton.removeAttr('disabled');
        } else {
            addToCartButton.attr('disabled', 'disabled');
        }
    });
}

export {
    init,
}
